import SectionLandingPage, {
  SectionLandingLink,
} from "components/components/SectionLandingPage/SectionLandingPage";
import React from "react";
import routeConstants from "utils/routeConstants";

const links: SectionLandingLink[] = [
  {
    title: "Short-term operating reserves",
    to: routeConstants.shortTermOperatingReserves,
    description:
      "STOR (Short Term Operating Reserve) is a service outside of the Balancing Mechanism by which NESO can issue instructions for reserve power.",
  },
  {
    title: "Balancing Mechanism data by BMU view",
    to: routeConstants.bmuView,
    description:
      "This page can be used to view Physical, Dynamic, Bid Offer and Balancing Services Volume data for a specific BM Unit.",
  },
  {
    title: "Balancing Mechanism data by market view",
    to: routeConstants.marketView,
    description:
      "This page can be used to view BM Unit data at Market level. Physical, Dynamic, Bid Offer and Balancing Services Volume data are available " +
      "for a specified date and time period.",
  },
  {
    title: "Adjustment data (NETBSAD)",
    to: routeConstants.adjustmentDataNetbsad,
    description:
      "NESO provides a set of adjustment buy/sell price values for each Settlement Period, shown in £/MWh.",
  },
  {
    title: "Adjustment actions (DISBSAD)",
    to: routeConstants.adjustmentActionsDisbsad,
    description:
      "NESO provides a set of adjustment actions, price and volume values for each Settlement Period.",
  },
  {
    title: "Market index prices",
    to: routeConstants.marketIndexPrices,
    description:
      "Market Index Price data is received from each of the appointed Market Index Data Providers (MIDPs) and reflects the price of wholesale " +
      "electricity in Great Britain for the relevant period in the short term markets.",
  },
  {
    title: "Derived data",
    to: routeConstants.derivedData,
    description:
      "The Derived data page displays an estimate of the Bid and Offer volumes accepted for each Bid-Offer pair by the System Operator for a " +
      "single BM Unit. The data is provided at both a per-acceptance and period total level.",
  },
  {
    title: "Detailed system prices",
    to: routeConstants.detailedSystemPrices,
    description:
      "The indicative price calculation is published 15 minutes after the effective Settlement Period based on parameters available at the " +
      "time the calculations were run. It shows a detailed breakdown of the indicative System Price calculations Stack either as Buy or " +
      "Sell Stacks listing all accepted actions included in the System Price calculations.",
  },
  {
    title: "System sell and buy prices",
    to: routeConstants.systemPrices,
    description:
      "The indicative price calculation is published 15 minutes after the effective Settlement Period based on parameters available at " +
      "the time the calculations were run.\n\n" +
      "System Buy/Sell Prices is displaying the indicative £/MWh for a settlement period. It is derived from Bid-Offer Acceptances, " +
      "BSAD and Market Index Data.",
  },
];

const Balancing: React.FC = () => (
  <SectionLandingPage
    title="Balancing"
    description={
      <>
        <p>
          The Balancing section provides data and insights into how the
          electricity system is balanced in real time and over forecast periods.
        </p>
        <p>
          You can find information on balancing actions, accepted bids and
          offers, system prices, and market data.
        </p>
        <p>
          From short-term operating reserves to adjustment actions and market
          index prices, it brings together the key insights that illustrate how
          stability is maintained across the system.
        </p>
      </>
    }
    links={links}
  />
);

export default Balancing;
